import { Row, Col, Card, Form, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useCartStore } from "../../../store/cart-store";
import { useProducts } from "../hooks/use-products";
import { useCategories } from "../hooks/use-categories";
import { FILES_BASE_URL } from "../../../config";
import Swal from 'sweetalert2';

const ProductsGridContent = () => {
  const { addItem } = useCartStore();
  const navigate = useNavigate();
  // Use our custom hooks
  const {
    currentProducts,
    isLoading,
    searchQuery,
    selectedCategory,
   /*  currentPage,
    totalPages,
    totalProducts,
    startIndex,
    endIndex,
    handlePageChange, */
    handleSearchChange,
    handleCategoryChange
  } = useProducts();

  const { categories } = useCategories();

  const handleAddToCart = (product: any) => {
    addItem(product);
    Swal.fire({
      title: 'Producto agregado',
      text: `${product.title} se agregó al carrito`,
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Comprar ahora',
      cancelButtonText: 'Continuar comprando',
      confirmButtonColor: "#48b44b",
      cancelButtonColor: '#d08f2c',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        navigate('/store/cart');
      }
    });
  };

  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-3">
        <Card.Body className="p-4">
          <div className="d-sm-flex justify-content-between align-items-center flex-wrap gap-2">
            <h4 className="fs-16 fw-medium mb-2 mb-sm-0">Productos</h4>

            <Form className="default-src-form">
              <div className="d-sm-flex flex-wrap gap-3">
                <div className="position-relative mb-2 mb-sm-0">
                  <Form.Control
                    type="search"
                    placeholder="Buscar productos..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className="rounded-3"
                  />
                  <span className="material-symbols-outlined fs-18 position-absolute top-50 start-0 translate-middle-y">

                  </span>
                </div>

                <div>
                  <Form.Select
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    className="form-control rounded-1 py-0 fs-14 ps-3 bg-transparent pe-5"
                  >
                    <option value="">Todas las categorías</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </Form.Select>

                </div>
              </div>
            </Form>
          </div>
        </Card.Body>
      </Card>

      {isLoading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Cargando productos...</p>
        </div>
      ) : (
        <>
          <Row className="g-4">
            {currentProducts.length > 0 ? (
              currentProducts.map((product) => {
                const imageUrl = product.images && product.images.length > 0
                  ? `${FILES_BASE_URL}/${product.images[parseInt(product.mainImage || "0") || 0]}`
                  : '/images/placeholder.png';

                const aditionalData = product.aditionalData[0];

                const price = aditionalData.price_usdt || 0;
                const localPrice = aditionalData.price_local_currency || 0;
                const currency = product.currency || 'COP'; // Usamos el currency del producto

                return (
                  <Col sm={6} lg={4} xxl={3} key={product._id}>
                    <div className="bg-white rounded-3 border-0 p-3 place-bid mb-4">
                      <Link
                        to={`/store/product-details/${product._id}`}
                        className="d-block mb-3 text-decoration-none position-relative"
                      >
                        <img
                          src={imageUrl}
                          className="rounded-3 w-100 object-fit-cover"
                          alt={product.title}
                          width={560}
                          height={414}
                          style={{ height: "200px" }}
                        />
                        <span className="btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0">
                          Ver Detalles
                        </span>
                      </Link>

                      <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                        <Link
                          to={`/store/product-details/${product._id}`}
                          className="d-flex align-items-center text-decoration-none"
                        >
                          <div className="flex-grow-1 ms-2">
                            <span className="fs-12">ID: {product._id.substring(0, 8)}...</span>
                            <h4 className="fw-semibold fs-14 mb-0">{product.title}</h4>
                          </div>
                        </Link>
                        <img
                          src="/images/verify.svg"
                          className="cursor"
                          alt="verify"
                          width={20}
                          height={20}
                          onError={(e) => {
                            e.currentTarget.style.display = 'none';
                          }}
                        />
                      </div>

                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center text-decoration-none">
                          <div className="flex-grow-1">
                            {price && price !== 0 ? (
                              <span className="fs-12 d-block mb-1">
                                Precio USDT: {" "}
                                <span className="fw-semibold text-secondary">
                                  ${price.toFixed(2)} USDT
                                </span>
                              </span>
                            ) : null}

                            <h4 className="fw-semibold fs-14 mb-0">
                              ${localPrice.toLocaleString()} {currency}
                            </h4>
                          </div>
                        </div>
                        <button
                          className="bg-transparent p-0 border-0"
                          onClick={() => handleAddToCart(product)}
                        >
                          <i className="ri-shopping-cart-2-line fs-20 position-relative top-2 text-primary"></i>{" "}
                          <span className="text-secondary fs-12 fw-semibold">
                            Agregar
                          </span>
                        </button>
                      </div>

                      <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                        <span className="badge bg-light text-black">
                          Entrega: {aditionalData.delivery_time_days || 0} días
                        </span>
                        <span className="badge bg-light text-black">
                          Puntos: {aditionalData.loyalty_points || 0}
                        </span>
                      </div>
                    </div>
                  </Col>
                );
              })
            ) : (
              <Col sm={12}>
                <p className="text-center mb-4">No se encontraron productos.</p>
              </Col>
            )}
          </Row>

          {/* {totalProducts > 0 && (
            <Card className="bg-white border-0 rounded-3 mb-4 mt-4">
              <Card.Body className="p-4">
                <div className="d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2">
                  <span className="fs-12 fw-medium">
                    Mostrando {startIndex + 1} a{" "}
                    {Math.min(endIndex, totalProducts)} de {totalProducts} Resultados
                  </span>

                  <nav aria-label="Page navigation">
                    <ul className="pagination mb-0 justify-content-center">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          <i className="ri-arrow-left-s-line"></i>
                        </button>
                      </li>

                      {[...Array(totalPages)].map((_, pageIndex) => (
                        <li key={pageIndex} className="page-item">
                          <button
                            className={`page-link ${currentPage === pageIndex + 1 ? "active" : ""}`}
                            onClick={() => handlePageChange(pageIndex + 1)}
                          >
                            {pageIndex + 1}
                          </button>
                        </li>
                      ))}

                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          <i className="ri-arrow-right-s-line"></i>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </Card.Body>
            </Card>
          )} */}
        </>
      )}
    </>
  );
};

export default ProductsGridContent;
